import React from 'react';

let componentMenu = {
    color: 'white',
    alignText: 'left',
    width: '100%',
    fontSize: '2rem',
    fontWeight: 'normal',
    letterSpacing: '3px',
    paddingTop: '1rem',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    paddingBottom: '1rem',
};

const mobile = {
    paddingTop: '0.5rem',
    paddingLeft: '0.5rem',
    paddingRight: '0.5rem',
    paddingBottom: '0rem',
};

const Menu = (props) => {
    if (props.mobile) {
        componentMenu = {...componentMenu, ...mobile};
    }

    return (
        <div style={componentMenu}>{props.header}</div>
    )
}

export default Menu
